/**
 * 权限管理实体
 */

import { useEffect, useState } from 'react';
import { Modal, Input, Row, Col, message, } from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    rff,
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '权限';

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [prefix, setPrefix] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setIsModalOpen(false);
        setLoading(false);
        setPrefix('');
        setName('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setPrefix(props.record.prefix);
            setName(props.record.name);
            setDescription(props.record.description);
        }
    }, [props.record]);

    const ok = () => {
        // 参数校验
        if (prefix === '') {
            messageApi.error('前缀不能为空！');
            return;
        }
        var rex = CNF.regex.authority_name.exec(name)
        if (rex == null || rex[0] !== name) {
            messageApi.error('权限名格式错误！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'authoritys' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'prefix': prefix,
                'name': name,
                'description': description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };

    return (
        <div>
            {contextHolder}
            <Modal
                width={540}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.isModalOpen}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}前缀</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setPrefix(e.target.value)}
                            value={prefix}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}权限名</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>描述</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='权限描述可写在这里...'
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                            value={description}
                        />
                    </Col>
                </Row>
            </Modal>
        </div>
    );
}

export default Entity